import { CONSENT_TYPES, getCookieConsent } from '../../utils/config/cookies';
import { isUserLoggedIn } from '../../utils/function';
import { canSyncPushNotifications } from './pushEligibility';
import { canUseWebPush, getPushPermissionState } from './pushPermission';

const DISMISS_KEY = 'jh_pushPromptDismissedAt';
/** Don't re-prompt for this long after the user dismisses the banner. */
const DISMISS_COOLDOWN_MS = 7 * 24 * 60 * 60 * 1000;

const safeGetDismissAt = () => {
  try {
    const raw = localStorage.getItem(DISMISS_KEY);
    if (!raw) return null;
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

const isPushPromptDismissed = () => {
  const dismissedAt = safeGetDismissAt();
  if (dismissedAt == null) return false;
  return Date.now() - dismissedAt < DISMISS_COOLDOWN_MS;
};

export const dismissPushPrompt = () => {
  try {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
  } catch {
    // ignore storage failures
  }
};

/** True when we should surface the in-app "Enable notifications" banner. */
export const shouldShowPushPermissionPrompt = () => {
  if (!canUseWebPush()) return false;
  if (!isUserLoggedIn()) return false;
  if (!canSyncPushNotifications()) return false;
  if (getCookieConsent() !== CONSENT_TYPES.ALL) return false;
  if (getPushPermissionState() !== 'default') return false;
  if (isPushPromptDismissed()) return false;
  return true;
};
